<script>
import formdate from "@/router/views/formcomponet/formdate.vue";
import forminput from "@/router/views/formcomponet/forminput.vue";
import formcombobox from "@/router/views/formcomponet/formcombobox.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import otakvim from "@/models/otakvim";
import useVuelidate from "@vuelidate/core";
export default {
  mixins: [Api, Sabit, otakvim],
  props: ["Id", "AddEdit", "BaslangicTarih"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: null,
      ModalOpen: false,
    };
  },
  components: {
    forminput,
    formdate,
    formcombobox
  },
  watch: {
    
    Id() {
      this.FormData = this.Id;
      if (this.FormData) {
        this.ModalOpen = true
        if(this.AddEdit == "Add"){
          this.FormData.Baslangic= this.BaslangicTarih
        }
       
      }
    },
    ModalOpen() {
     
      if (this.ModalOpen == false) {  
        this.$emit("ModalOpen"); 
      }
    }
  },
  methods: {
    onSubmit() { 
      this.v$.$touch();
      if (!this.v$.$invalid) {
        if (this.AddEdit == "Add") {
          this.FormData.Userid = this.TokenUserId
          this.Post("otakvim", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        } else {
          this.Update("otakvim", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        }
      }
    },
    
    Get() { },
    Sil(Id){
      this.Delete('otakvim', Id) 
          this.ModalOpen = false
          this.$emit("ModalOpen");  
    }
  },
};
</script>
<template>  
  <b-modal v-model="ModalOpen" id="otakvim" size="lg" :title="this.AddEdit == 'Edit'
    ? 'Kayıt Düzenle'
    : 'Yeni Kayıt Ekle'
    " title-class="font-18" hide-footer>
    <Form @submit.prevent="onSubmit" v-if="FormData">   
 
      <forminput :FormDataType="FormDataType.Baslik" :Value="FormData.Baslik" :v="v$.FormData.Baslik"
        @input="FormData.Baslik = $event.target.value" />

      <formdate :FormDataType="FormDataType.Baslangic" :Value="FormData.Baslangic" :v="v$.FormData.Baslangic"
        @input="FormData.Baslangic = $event.target.value" />

      <formdate :FormDataType="FormDataType.Bitis" :Value="FormData.Bitis" :v="v$.FormData.Bitis"
        @input="FormData.Bitis = $event.target.value" />

      <formcombobox :FormDataType="FormDataType.Kategori" :Value="FormData.Kategori" :v="v$.FormData.Kategori"
        @input="FormData.Kategori = $event.target.value" /> 

      <button class="btn btn-danger m-2" type="button" @click="Sil(FormData.Id)">
        Sil
      </button> 
      <button class="btn btn-primary" type="submit">
        Kaydet
      </button>
    </Form>
  </b-modal>
</template>
